export default __webpack_public_path__ + "static/media/sportsbra-small-left-toobig.ec91b5a6.jpg";